// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__FW-FY","header":"Messages_header__17oZm"};